import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class VendorService {
  url = environment.apiUrl
 
  constructor(private http:HttpClient,) { }

  addNewVendor(object:any){
    return this.http.post(this.url+'/ecitation-services/saveVendor',object,)
  }
  addNewCourt(object:any){
    return this.http.post(this.url+'/ecitation-services/saveCourt',object)
  }

  

  getAllVendor(){
   
    return this.http.get(this.url+'/ecitation-services/allVendors')
  }
  getUnAssignedCourts(){
   
    return this.http.get(this.url+'/ecitation-services/allUnassignedCourts')
  }

  getAllCourt(){
   
    
    return this.http.get(this.url+'/ecitation-services/allCourts')
  }
  getAllStatusCodes(){
    
    return this.http.get(this.url+'/ecitation-services/allCourtStatusCds')
  }


}

